import {
  GET_EXPENSES_FAILURE,
  GET_EXPENSES_REQUEST,
  GET_EXPENSES_SUCCESS,
  GET_EXPENSES_PENDING,
} from "./actionTypes";

// NOTES

export const getExpensesRequest = (payload) => {
  return {
    type: GET_EXPENSES_REQUEST,
    payload,
  };
};

export const getExpensesSuccess = (payload) => {
  return {
    type: GET_EXPENSES_SUCCESS,
    payload,
  };
};

export const getExpensesFailure = (payload) => {
  return {
    type: GET_EXPENSES_FAILURE,
    payload,
  };
};

export const getExpensesPending = () => {
  return {
    type : GET_EXPENSES_PENDING,
  }
}
